import { useSelector } from 'react-redux';
import {
  FieldErrors,
  FieldValues,
  UseFormClearErrors,
  UseFormGetValues,
  UseFormRegister,
  UseFormResetField,
  UseFormSetError,
  UseFormSetValue,
  UseFormTrigger,
  UseFormWatch,
} from 'react-hook-form';

import { RootState, validateFormField } from '@msc-b2c/shared-utils';
import { ZipCodeInput } from './zipcodeinput/ZipCodeInput';
import { CityInput } from './cityinput/CityInput';

type AddressSearchInput = {
  disabled?: boolean;
  label: string;
  secondLabel: string;
  name: string;
  secondName: string;
  isLowerLabel?: boolean;
  index: number;
  placeholder: string;
  secondPlaceholder: string;
  verifyZipCodeButtonLabel?: string;
  zipCodeValidationErrorMessage?: string;
  cityValidationErrorMessage?: string;
  additionalValidationObj?: FieldValues;
  clearErrors: UseFormClearErrors<FieldValues>;
  errors: FieldErrors;
  setError: UseFormSetError<FieldValues>;
  getValues: UseFormGetValues<FieldValues>;
  setValue: UseFormSetValue<FieldValues>;
  register: UseFormRegister<FieldValues>;
  resetField: UseFormResetField<FieldValues>;
  trigger: UseFormTrigger<FieldValues>;
  watch: UseFormWatch<FieldValues>;
  validationRulesContainer?: any;
  styleOptions?: string;
};

export function AddressSearchInput({
  disabled,
  isLowerLabel,
  index,
  label,
  secondLabel,
  name,
  secondName,
  placeholder,
  secondPlaceholder,
  verifyZipCodeButtonLabel,
  zipCodeValidationErrorMessage = '',
  cityValidationErrorMessage = '',
  clearErrors,
  errors,
  setError,
  getValues,
  setValue,
  register,
  resetField,
  trigger,
  watch,
  validationRulesContainer,
  styleOptions,
}: Readonly<AddressSearchInput>) {
  const { selectedCountry } = useSelector((state: RootState) => state.addressManagement);
  const { noPostCodeCountries } = useSelector(
    (state: RootState) => state.genericConfigs.configs.b2cCommerceConfig
  );

  return noPostCodeCountries?.includes(selectedCountry) ? (
    <CityInput
      disabled={disabled}
      index={index}
      isLowerLabel={isLowerLabel}
      label={secondLabel}
      name={secondName}
      placeholder={secondPlaceholder}
      cityValidationErrorMessage={cityValidationErrorMessage}
      clearErrors={clearErrors}
      errors={errors}
      setError={setError}
      getValues={getValues}
      setValue={setValue}
      register={register}
      resetField={resetField}
      validation={{
        validate: (v) => validateFormField(v, validationRulesContainer || []),
        onBlur: () => trigger(`${secondName}`),
        onChange: () => trigger(`${secondName}`),
      }}
      watch={watch}
      selectedCountry={selectedCountry}
      styleOptions={`cmp-form-text__zip-code ${styleOptions}`}
    />
  ) : (
    <ZipCodeInput
      disabled={disabled}
      index={index}
      isLowerLabel={isLowerLabel}
      label={label}
      name={name}
      placeholder={placeholder}
      verifyZipCodeButtonLabel={verifyZipCodeButtonLabel}
      zipCodeValidationErrorMessage={zipCodeValidationErrorMessage}
      clearErrors={clearErrors}
      errors={errors}
      setError={setError}
      getValues={getValues}
      setValue={setValue}
      register={register}
      resetField={resetField}
      validation={{
        validate: (v) => validateFormField(v, validationRulesContainer || []),
        onBlur: () => trigger(`${name}`),
      }}
      selectedCountry={selectedCountry}
      styleOptions={`cmp-form-text__zip-code ${styleOptions}`}
    />
  );
}
